import React from 'react';

const ChoosePlanHeader = () => {
  return (
    <div className="tw-mb-24 tw-text-center">
      <h1 className="tw-text-headline-md xs:tw-text-headline-lg tw-mt-0 tw-mb-4 tw-font-serif">
        Choose the plan that’s right for you
      </h1>
      <h3 className="tw-text-body-sm xs:tw-text-[16px] tw-font-bold tw-m-0 tw-font-sans">
        Join high-powered tech and business leaders who read The Information every day.
      </h3>
    </div>
  );
};

export default ChoosePlanHeader;
